const EventRegistrationButton = ({event, extraClasses = []}) => {
    // The CRM controls whether the register button shows. Only an explicit `false` hides it;
    // events created before this field existed (undefined) continue to show the button.
    if (event.bio_displayregisterbutton === false) {
        return null;
    }

    // If the event has no offsite registration URL and no CRM registration URL, do not render anything.
    if (!event.offsiteRegistration && !event.registrationUrl) {
        return null;
    }

    const baseClasses = [
        'button',
        'yellow',
    ]

    const buttonClasses = extraClasses.length ? [...baseClasses, ...extraClasses] : baseClasses;

    // The CRM can override the default button label per-event; fall back to the standard label.
    const label = event.bio_registerbuttonoverridetext || 'Register Now';

    if (event.offsiteRegistration) {
        return (
            <a
                className={buttonClasses.join(' ')}
                href={event.registrationUrl}
                target="_blank"
                rel="noreferrer"
            >
                {label}
            </a>
        )
    }

    return (
        <a className={buttonClasses.join(' ')} href={event.registrationUrl}>
            {label}
        </a>
    )
}

export default EventRegistrationButton;
